import * as React from 'react'
import * as UI from '@brewlogix/blx-ui'
import classNames from 'classnames'
import { useStickyNav } from 'src/features/locations/state/useStickyNav'

interface IAbout {
    description: string
    pageLocation: 'location' | 'brewer'
    selectedElement: string
    aboutRef?: React.Ref<HTMLDivElement>
}

const About: React.FC<IAbout> = ({ description, pageLocation, selectedElement, aboutRef }) => {
    const { space } = useStickyNav()
    const label = pageLocation === 'location' ? 'Our Culture' : 'About'
    const text = description || 'Description coming soon...'

    return (
        <div className={classNames('space-y-4  md:space-y-6', space)} id='about' ref={aboutRef}>
            <UI.Heading text={label} size='h4' type='h2' customClasses='text-xl lg:text-2xl' />
            <p className=' text-base '>{text}</p>
        </div>
    )
}

export default About
